import { create } from 'zustand';
import { LighthouseEnums } from '../types';

interface SystemStoreData {
   enums: LighthouseEnums;
}

interface SystemStoreActions {
   clear: () => void;

   setEnums: (enums: LighthouseEnums) => void;
}

export type SystemStore = SystemStoreData & SystemStoreActions;

const initialState: SystemStoreData = {
   enums: {} as LighthouseEnums,
};

export const useSystemStore = create<SystemStore>()(
   (set, get): SystemStore => ({
      ...initialState,

      clear: () => set({ ...initialState }),

      setEnums: (enums: LighthouseEnums) => set({ enums }),
   }),
);
